import React from 'react';
import arrow from '../../../images/icons/ic-arrow.svg';
import contestants from '../../../images/icons/ic-contestants.svg';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = ('0' + date.getDate()).slice(-2);
  const month = date.toLocaleString([], { month: 'short' });
  return `${day}. ${month}`;
};

const formatDateWithYear = (dateString) => {
  const date = new Date(dateString);
  const day = ('0' + date.getDate()).slice(-2);
  const month = date.toLocaleString([], { month: 'short' });
  const year = date.getFullYear();
  return `${day}. ${month}, ${year}`;
};

const ChallengeSearchItem = ({ challenge }) => {
  const from = formatDate(challenge.from);
  const to = formatDateWithYear(challenge.to);
  const segments = challenge.segments.length === 1 ? 'segment' : 'segments';

  // Get unique segment types for display
  const uniqueSegmentTypes = challenge.segments.reduce((acc, segment) => {
    if (!acc.find((s) => s.segment_type_id === segment.segment_type_id)) {
      acc.push(segment);
    }
    return acc;
  }, []);

  return (
    <a
      href={challenge.url}
      className='flex justify-between w-full border-b border-border-secondary last:border-none px-4 md:px-6 py-12pt hover:bg-background-quinary'
    >
      <div className='flex flex-1 items-center min-w-0'>
        {challenge.distance_challenge_type_icon_url ? (
          <span className='flex h-6 w-6 mr-1 text-body-inverted rounded-full justify-center items-center bg-primary shrink-0'>
            <img
              src={challenge.distance_challenge_type_icon_url}
              className='h-4'
              alt=''
            />
          </span>
        ) : (
          uniqueSegmentTypes.map((segment, segIndex) => (
            <span
              key={segIndex}
              className='flex h-6 w-6 mr-1 text-body-inverted rounded-full justify-center items-center bg-primary shrink-0'
            >
              <img src={segment.segment_type_icon_url} className='h-4' alt='' />
            </span>
          ))
        )}
        <div className='min-w-0 ml-3'>
          <h5 className='truncate m-0 mt-4pt font-text body-text'>
            {challenge.name}
          </h5>
          <p className='truncate m-0 mini-text text-text-grey-600'>
            {from} - {to} <span className='hidden medium:inline'>| </span>
            <span className='hidden medium:inline'>
              {challenge.segments.length} {segments}
            </span>
          </p>
        </div>
      </div>
      <div className='flex items-center'>
        <span>
          <img src={contestants} className='w-4 mr-1' alt='' />
        </span>
        <span className='pr-8 body-text'>
          {challenge.number_of_challengers}
        </span>
        <span>
          <img src={arrow} className='w-4' alt='' />
        </span>
      </div>
    </a>
  );
};

export default ChallengeSearchItem;
